import { RG_TYPE } from "@project-rouge/rg-core";
function getEntranceCount(sequence) {
	let count = 0;
	for (let i = 0; i < sequence.length; i++) if (sequence[i].unit.type === RG_TYPE.Entrance) count++;
	return count;
}
export { getEntranceCount };

//# sourceMappingURL=index133.js.map